/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-no-undef */
import ReactMarkdown from "react-markdown";
import {
  Tag,
  Tooltip,
  Col,
  Row,
  Form,
  Select,
  Checkbox,
  Skeleton,
  Collapse,
  Typography,
} from "antd";
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import moment from "moment-timezone";
import {
  FaRegUser,
  FaTag,
  FaUserAlt,
  FaUserFriends,
  FaHistory,
  FaRegCalendar,
  FaRegCalendarCheck,
} from "react-icons/fa";
//import { useOrgSettings } from 'hooks/useOrgSettings';
import { USER_TASK_STATUS_MAP } from "lib/constants";
import SelectUsers from "./select-users";

const FormItem = Form.Item;
const { Text, Paragraph } = Typography;

const UserTaskForm = (props) => {
  // const { currentOrganization, canManagePolicy } = useAuth();
  const canManagePolicy = {
    USER_TASK: true,
  };
  const {
    form,
    userTaskData,
    userTaskLoading,
    isMobile,
    handleDocumentViewer,
  } = props;
  const organizationId = ""; //currentOrganization?.id;
  //const PatientLabel = useOrgSettings(organizationId, 'Patient');
  const singularLabel = "Patient"; //PatientLabel?.Patient?.singular || 'Patient';

  const formItemLayout = {
    labelCol: { span: 10 },
    wrapperCol: { span: 14 },
    colon: false,
    labelAlign: "left",
    style: { marginBottom: "5px" },
  };
  const formItemLayoutFull = {
    labelCol: { span: isMobile ? 10 : 5 },
    wrapperCol: { span: isMobile ? 14 : 19 },
    colon: false,
    labelAlign: "left",
    style: { marginBottom: "5px" },
  };

  const currentStatusObj =
    (userTaskData && USER_TASK_STATUS_MAP[userTaskData.status]) ||
    USER_TASK_STATUS_MAP.DEFAULT;
  if (userTaskLoading) {
    return (
      <div style={{ margin: "10px 24px" }}>
        <Skeleton active />
        <Skeleton active />
        <Skeleton active />
      </div>
    );
  }
  const firstItem = userTaskData && (
    <FormItem
      {...formItemLayout}
      key="1"
      labelAlign="left"
      label={
        <span>
          <FaUserAlt
            style={{
              verticalAlign: "middle",
              marginRight: 7,
              fontSize: 16,
              color: "#71afb4",
            }}
          />
          Relates To
        </span>
      }
    >
      {userTaskData && userTaskData.patient && (
        <a
          href={`/patients/edit?id=${userTaskData.patient.id}`}
          style={{ fontWeight: "bold", fontSize: 16, color: "#000" }}
        >
          <Tooltip placement="topLeft" title={singularLabel}>
            {userTaskData.patient.firstName} {userTaskData.patient.lastName}
          </Tooltip>
        </a>
      )}
    </FormItem>
  );
  const secondItem = userTaskData && (
    <FormItem
      {...formItemLayout}
      key="2"
      labelAlign="left"
      label={
        <span>
          <FaRegCalendar
            style={{
              verticalAlign: "middle",
              marginRight: 7,
              fontSize: 16,
              color: "#71afb4",
            }}
          />
          Created
        </span>
      }
    >
      <div style={{ fontSize: 15 }}>
        {userTaskData &&
          userTaskData.createdAt &&
          moment(userTaskData.createdAt)
            .tz(moment.tz.guess())
            .format("MMM D hh:mma")}
      </div>
    </FormItem>
  );
  const thirdItem = userTaskData && (
    <FormItem
      {...formItemLayout}
      key="3"
      labelAlign="left"
      label={
        <span>
          <FaUserFriends
            style={{
              verticalAlign: "middle",
              zoom: "80%",
              marginRight: 7,
              fontSize: 16,
              color: "#71afb4",
            }}
          />
          Assigned Group(s)
        </span>
      }
    >
      {userTaskData.assignedUserGroups &&
        userTaskData.assignedUserGroups.length > 0 &&
        userTaskData.assignedUserGroups
          .map((group, index) => group && group.name)
          .join(", ")}
    </FormItem>
  );
  const fourthItem = userTaskData && (
    <FormItem
      {...formItemLayout}
      key="4"
      label={
        <span>
          <FaRegUser
            style={{
              height: 20,
              verticalAlign: "middle",
              marginRight: 7,
              fontSize: 16,
              color: "#71afb4",
            }}
          />
          Care Manager(s)
        </span>
      }
      labelAlign="left"
    >
      {userTaskData && !userTaskData.careManager && <span>None</span>}
      {userTaskData && userTaskData.careManager && (
        <a
          href={`/members/edit?id=${userTaskData.careManager.id}`}
          style={{ color: "#1890ff", textDecoration: "underline" }}
        >
          <Tooltip placement="topLeft" title="Care Manager">
            {userTaskData.careManager.fullName}
          </Tooltip>
        </a>
      )}
    </FormItem>
  );
  const fifthItem = userTaskData && (
    <FormItem
      {...formItemLayout}
      key="5"
      labelAlign="left"
      label={
        <span style={{ margin: 0 }}>
          <FaHistory
            style={{
              verticalAlign: "middle",
              marginRight: 7,
              fontSize: 16,
              color: "#71afb4",
            }}
          />
          Status
        </span>
      }
      name="status"
      rules={[{}]}
    >
      <span style={{ fontWeight: "bold", fontSize: 16, color: "#000" }}>
        {currentStatusObj.label}
      </span>
    </FormItem>
  );
  const sixthItem = userTaskData && (
    <FormItem
      {...formItemLayout}
      key="6"
      labelAlign="left"
      label={
        <span>
          <FaRegCalendarCheck
            style={{
              verticalAlign: "middle",
              marginRight: 7,
              fontSize: 16,
              color: "#71afb4",
            }}
          />
          Due
        </span>
      }
    >
      <div style={{ fontSize: 15, fontWeight: "bold", color: "#000" }}>
        {userTaskData &&
          userTaskData.dueDateTime &&
          moment(userTaskData.dueDateTime)
            .tz(moment.tz.guess())
            .format("MMM D  hh:mma")}
      </div>
    </FormItem>
  );
  const seventhItem = userTaskData && (
    <SelectUsers
      canManagePolicy={canManagePolicy}
      userTaskData={userTaskData}
      organizationId={organizationId}
      formItemLayout={formItemLayout}
      key="7"
    />
  );

  return (
    userTaskData && (
      <Form form={form} layout="horizontal">
        <div style={{ marginTop: 10 }}>
          <Row className="horizontal-gutter" style={{ marginBottom: 16 }}>
            <Text
              style={{
                fontFamily: "'Lato-Italic', 'Lato Italic', 'Lato'",
                fontSize: 14,
                fontStyle: "italic",
                fontWeight: 400,
                margin: 0,
                color: "#4D4D4D",
                lineHeight: "20px",
                marginLeft: 20,
              }}
            >
              {userTaskData.notes}
            </Text>
          </Row>
          <Collapse
            defaultActiveKey={["user", "documents", "info"]}
            expandIconPosition="right"
            expandIcon={(props) =>
              props.isActive ? <UpOutlined /> : <DownOutlined />
            }
          >
            <Collapse.Panel
              header={
                <>
                  {userTaskData?.patient?.firstName}{" "}
                  {userTaskData?.patient?.lastName}
                  &nbsp;&nbsp;|&nbsp;&nbsp;Status - {currentStatusObj.label}
                </>
              }
              key="user"
            >
              <Row style={{ marginBottom: 0 }}>
                <Col span={isMobile ? 24 : 12} className="first-column">
                  {isMobile
                    ? [firstItem, fifthItem, secondItem, sixthItem]
                    : [firstItem, secondItem, thirdItem, fourthItem]}
                </Col>
                <Col span={isMobile ? 24 : 12}>
                  {isMobile
                    ? [thirdItem, seventhItem, fourthItem]
                    : [fifthItem, sixthItem, seventhItem]}
                </Col>
              </Row>
              <FormItem
                {...formItemLayoutFull}
                labelAlign="left"
                label={
                  <span>
                    <FaTag
                      style={{
                        verticalAlign: "middle",
                        marginRight: 7,
                        fontSize: 16,
                        color: "#71afb4",
                      }}
                    />
                    Task Tags
                  </span>
                }
                name="userTags"
                rules={[{ type: "array" }]}
                initialValue={userTaskData.userTags || []}
              >
                <Select
                  showSearch
                  showAction={["focus", "click"]}
                  mode="tags"
                  size="middle"
                  disabled={!canManagePolicy["USER_TASK"]}
                  tokenSeparators={[","]}
                  dropdownStyle={{ display: "none" }}
                  placeholder="User Tags"
                  style={{ width: "100%" }}
                />
              </FormItem>
              <FormItem
                {...formItemLayoutFull}
                labelAlign="left"
                label={
                  <span>
                    <FaTag
                      style={{
                        verticalAlign: "middle",
                        marginRight: 7,
                        fontSize: 16,
                        color: "#71afb4",
                      }}
                    />
                    System Tags
                  </span>
                }
              >
                {((userTaskData && userTaskData.tags) || []).map(
                  (tag, index) => (
                    <Tag
                      key={`user_task_tag_${userTaskData.id}_${tag}_${index}`}
                    >
                      {tag}
                    </Tag>
                  ),
                )}
              </FormItem>
            </Collapse.Panel>
            {userTaskData.detailedInstructions && (
              <Collapse.Panel
                header="Instructions &amp; Information"
                key="info"
              >
                <div>
                  <Row>
                    <Paragraph
                      style={{
                        fontSize: 12,
                        margin: "10px 0",
                        lineHeight: "20px",
                      }}
                    >
                      <ReactMarkdown
                        className="react-markdown-class"
                        children={
                          userTaskData && userTaskData.detailedInstructions
                        }
                      />
                    </Paragraph>
                  </Row>
                  {userTaskData && userTaskData.isReferrable && (
                    <Row>
                      <Col span={6}>
                        <FormItem
                          {...{ ...formItemLayout, wrapperCol: { span: 24 } }}
                          label=""
                          name="referToHomeHealthCare"
                          rules={[]}
                          labelAlign="left"
                          // initialValue={userTaskData.referToHomeHealthCare || false}
                        >
                          <Checkbox>Refer to home healthcare</Checkbox>)
                        </FormItem>
                      </Col>
                      <Col span={6}>
                        <FormItem
                          {...{ ...formItemLayout, wrapperCol: { span: 24 } }}
                          label=""
                          name="referToPersonalCare"
                          rules={[]}
                          labelAlign="left"
                          // initialValue={userTaskData.referToPersonalCare || false}
                        >
                          <Checkbox>Refer to personal care</Checkbox>)
                        </FormItem>
                      </Col>
                    </Row>
                  )}
                </div>
              </Collapse.Panel>
            )}
            {userTaskData?.attachments?.length && (
              <Collapse.Panel header="Attachments" key="documents">
                <div>
                  <Row>
                    <a
                      onClick={() => handleDocumentViewer(true)}
                      style={{ color: "#1890ff", cursor: "pointer" }}
                    >
                      Click here to view attachments
                    </a>
                  </Row>
                </div>
              </Collapse.Panel>
            )}
          </Collapse>
        </div>
      </Form>
    )
  );
};

export default UserTaskForm;
